import { chartColours } from "../../../themes/colours";

export default {
  layer: {
    id: "travel-time",
    type: "fill",
    filter: ['!', ['has', 'focus_point']],
    paint: {
      "fill-color": chartColours.ldnDkPink,
      "fill-opacity": 0.3,
      "fill-outline-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "travel-time",
    type: "geojson",
    data: {
      type: "FeatureCollection",
      features: [],
    },
  },
  overLayers: [
    {
      id: "travel-time-focus-point",
      type: "circle",
      filter: ['has', 'focus_point'],
      paint: {
        'circle-radius': 3,
        'circle-color': '#515a5e',
        'circle-stroke-color': 'black',
        'circle-stroke-width': 2,
      },
      layout: {
        visibility: "none",
      },
    },
  ],
  labels: {
    parent: "Travel Time",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: false,
  category: "hsds",
  requiresGis2Token: true,
  customFetch: true,
  info: {
    shortDescription: "Travel time determined from the geographical centre point of the high street boundary.",
    longDescriptionTitle: "Travel Time Isochrones",
    longDescription: [
      (<><b>Travel time information is only available to members of the High Streets Data Service (HSDS).</b> For members the login button is at the bottom right of the sidebar.</>),
      "Travel time is the time-of-travel distance determined from the geographical centre point of the high street boundary. This can be changed using the 'Set Starting Point' button. Public transport travel times are calculated using midday on the nearest Wednesday as the default departure time, assuming normal daytime public transport operations.",
      "Public transport travel times include a 10-minute walking time to/from stations and bus stops, which is why walking and public transport times are similar, sometimes identical, for low travel times (<= 10 minutes).",
      (<>Travel time isochrones are sourced through a commercial service available here: <a href="https://docs.traveltime.com/api/overview/introduction" target="_blank">TravelTime (Isochrone API)</a>. Specific information on the dataset and methodology are available here: <a href="https://help.traveltime.com/en/collections/6630882-transport-models" target="_blank">TravelTime FAQs</a>.</>),
    ]
  }
}